import { buildBaseCommerceAPIRequest, } from '../common/base-commerce-api-request-builder.js';
export const buildPlanRequest = (state, navigatorContext) => {
    const baseRequest = buildBaseCommerceAPIRequest(state, navigatorContext);
    return {
        ...baseRequest,
        context: {
            ...baseRequest.context,
            capture: false,
        },
        query: state.commerceQuery.query,
    };
};
